import { useEffect, useRef } from 'react';

import { useAppSelector } from 'shared/lib';

import { checkIsFormFullFilledSelector } from 'entities/creditForm';
import { isLoggedSelector } from 'entities/user';

import { useSendLoansContactData } from 'features/SendLoansContactData';

export const useSummarySendContact = () => {
  const isAuth = useAppSelector(isLoggedSelector);
  const isFormReady = useAppSelector(checkIsFormFullFilledSelector);
  const isContactSend = useRef(isFormReady);
  const sendContact = useSendLoansContactData();

  useEffect(() => {
    if (!isContactSend.current && isFormReady && isAuth) {
      isContactSend.current = true;
      sendContact();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFormReady, isAuth]);
};
